<ng-container [ngSwitch]="block.quizType">
  <ng-container *ngSwitchCase="quizTypes.BOOLEANCHOICE">
    <div class="answer-multi">
      <mat-checkbox [checked]="block.trueOrFalse === true" disabled
        >True &nbsp;</mat-checkbox
      >
      <br /><br />
      <mat-checkbox [checked]="block.trueOrFalse === false" disabled
        >False &nbsp;</mat-checkbox
      >
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="quizTypes.MULTIPLECHOICE">
    <app-shared-multiple-choice-viewer
      [quiz]="block"
    ></app-shared-multiple-choice-viewer>
  </ng-container>
  <ng-container *ngSwitchCase="quizTypes.FREEANSWER">
    <div class="answer-free">
      <label>(Freeform answer)</label>
      <div class="option-row">
        <div class="answer-free--item">
          <p>{{ block.text }}</p>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
